export default __webpack_public_path__ + "static/media/plytkaprzed.ded1b327.jpg";